// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3haWD","colMin":"styles_colMin__3cZn0"};